import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getErrorMessage(e: unknown): string {
  if (e instanceof Error) return e.message
  if (typeof e === 'string') return e
  if (e && typeof e === 'object') {
    const maybeMsg = (e as { message?: unknown }).message
    if (typeof maybeMsg === 'string') return maybeMsg
  }
  try {
    return JSON.stringify(e)
  } catch {
    return String(e)
  }
}

type ApiErrorShape = string | { message?: string; code?: string } | null | undefined

export function apiErrorToString(err: ApiErrorShape): string {
  if (!err) return ''
  if (typeof err === 'string') return err
  if (typeof err === 'object' && typeof err.message === 'string') return err.message
  return ''
}

export function getApiErrorMessage(e: unknown): string {
  if (e && typeof e === 'object') {
    const resp = (e as { response?: { data?: { error?: ApiErrorShape; message?: string } } }).response
    const dataErr = resp?.data?.error
    const fromErr = apiErrorToString(dataErr ?? null)
    if (fromErr) return fromErr
    const dataMsg = resp?.data?.message
    if (typeof dataMsg === 'string' && dataMsg) return dataMsg
  }
  return getErrorMessage(e)
}